// 公告横幅（系统维护 / 公告 Banner）枚举与选项定义

export type BannerScope = 'global' | 'perps' | 'prediction' | 'fingertip';
export type BannerLevel = 'maintenance' | 'notice' | 'alert';
export type BannerSource = 'manual' | 'auto';
export type BannerStatus = 'normal' | 'maintenance' | 'degraded' | 'resolved';

export interface BannerLocalizedText {
  zh?: string;
  en?: string;
}

// 作用域：global 全平台；其余为具体板块（不暴露供应商，仅显示板块名）
export const SCOPE_CHOICES: { id: BannerScope; name: string; color: string }[] = [
  { id: 'global', name: 'module.announcementPopup.scopeGlobal', color: '#9E9E9E' },
  { id: 'perps', name: 'module.announcementPopup.scopePerps', color: '#7C4DFF' },
  { id: 'prediction', name: 'module.announcementPopup.scopePrediction', color: '#00BFA5' },
  { id: 'fingertip', name: 'module.announcementPopup.scopeFingertip', color: '#FF9100' },
];

// 级别：告警 > 维护 > 公告（命中优先级）
export const LEVEL_CHOICES: { id: BannerLevel; name: string; color: string }[] = [
  { id: 'maintenance', name: 'module.announcementPopup.levelMaintenance', color: 'warning' },
  { id: 'notice', name: 'module.announcementPopup.levelNotice', color: 'info' },
  { id: 'alert', name: 'module.announcementPopup.levelAlert', color: 'error' },
];

// 来源：手动（运营配置，优先级高）/ 自动（状态监测生成）
export const SOURCE_CHOICES: { id: BannerSource; name: string }[] = [
  { id: 'manual', name: 'module.announcementPopup.sourceManual' },
  { id: 'auto', name: 'module.announcementPopup.sourceAuto' },
];

// 自动状态（仅 source=auto 时可选）
export const STATUS_CHOICES: { id: BannerStatus; name: string }[] = [
  { id: 'normal', name: 'module.announcementPopup.statusNormal' },
  { id: 'maintenance', name: 'module.announcementPopup.statusMaintenance' },
  { id: 'degraded', name: 'module.announcementPopup.statusDegraded' },
  { id: 'resolved', name: 'module.announcementPopup.statusResolved' },
];

// 是否可关闭的级别缺省值：alert 默认不可关，其余默认可关。
export const defaultDismissibleByLevel = (level?: BannerLevel): boolean => level !== 'alert';
